import React from 'react'
import parentStyles from '../styles.module.scss'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import SearchTextBox from 'srcReact/components/common2/SearchTextBox'
import { useSelector } from 'react-redux'
import Spinner from 'srcReact/components/common2/Spinner'
import Avatar from 'srcReact/components/common2/Avatar'
import Icon from 'srcReact/components/icons/Icon'
import NoResultInSearch from '../../NoResultInSearch'
import BackNavigation from 'srcReact/components/common2/BackNavigation'

export default function Desktop({
  membersToInvite,
  lastMemberRef,
  search,
  goToSearchScreen,
  startConversation,
  removeMemberFromInvite,
  addMemberToInvite,
  showUserLightModal,
  isMemberAddedForInvitation,
  handleSearch
}) {
  const { t } = useTranslation()
  const {
    common: { isMobile },
    messenger: { searchedMembers, loadingInSidebar, searchedMemberError }
  } = useSelector((state) => state)
  return (
    <React.Fragment>
      <BackNavigation className={styles.goBack} customHandleBack={goToSearchScreen} />

      {membersToInvite && membersToInvite.length > 0 ? (
        <div className={styles.addedMembersOuterContainer}>
          <div
            className={`${styles.addedMembers} ${
              membersToInvite.length === 1
                ? styles.addedMembersSingle
                : membersToInvite.length === 2
                ? styles.addedMembersDouble
                : styles.addedMembersMultiple
            }`}>
            {membersToInvite.map((member) => (
              <div key={member.user_id} className={styles.addedMemberInList}>
                <button
                  type='button'
                  onClick={() => removeMemberFromInvite(member)}
                  className={parentStyles.removeMemberButton}>
                  <Icon name='close24' size='large' styleModifier={parentStyles.addRemoveIcon} />
                </button>
                <Avatar
                  key={'member_' + member.user_id}
                  userId={member.user_id}
                  profilePicture={member.profile_picture_url}
                  firstname={member.firstname}
                  lastname={member.lastname}
                  imgWrapperSize='small'
                  containerCSS={styles.addedMemberAvatar}
                  showImageAsDecorative={true}
                  onClickAction={() => showUserLightModal(member)}
                  mimeType={member.mime_type}
                  originalTag={member.original_tag}
                  isOriginal={member.is_original}
                  userStatus={member.status}
                  withExpertiseGroup={member.with_expertise_group}
                />
                <div className={parentStyles.userProfile}>
                  <div className={parentStyles.memberName}>
                    {member.status === 'deleted' ? t('global.deletedUser') : `${member.firstname} ${member.lastname}`}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className={styles.info}>{t('messenger.addMemberInfo')}</div>
      )}
      <React.Fragment>
        <button
          type='button'
          onClick={startConversation}
          className={`${styles.startButton} ${
            membersToInvite.length === 0 ? styles.startButtonDisabled : styles.startButtonActive
          } `}>
          {t('messenger.startConversationButton')}
        </button>

        <SearchTextBox
          minimumSearchChar={2}
          {...(search?.length === 0 && { clear: true })}
          size='large'
          iconPosition='start'
          iconCSS={styles.searchIcon}
          placeholder={t('formlabel.searchMemberPlaceholder1')}
          handleSearch={handleSearch}
          cssClass={parentStyles.searchContainer}
          inputCssClass={`${parentStyles.inputCssClass} ${styles.inputCssClass}`}
        />
        <div className={`${parentStyles.list} ${styles.list}`}>
          {!loadingInSidebar && !searchedMemberError && search?.length >= 3 && searchedMembers.length === 0 && (
            <NoResultInSearch customCss={parentStyles.noresult} />
          )}
          {searchedMembers &&
            searchedMembers.length > 0 &&
            searchedMembers
              .filter((member) => !isMemberAddedForInvitation(membersToInvite, member))
              .map((member, index) => {
                const isLastMember = searchedMembers.length === index + 1
                const regexSearchedKey = new RegExp(search, 'gi')
                const completeName = `${member.firstname} ${member.lastname}`
                const completeNameHTML = completeName.replace(
                  regexSearchedKey,
                  `<span class=${styles.searchedValue} role="presentation">$&</span>`
                )
                return (
                  <div
                    key={member.user_id}
                    ref={isLastMember ? lastMemberRef : null}
                    className={parentStyles.memberInList}>
                    {/* <div className={parentStyles.border}></div> */}
                    <div className={parentStyles.memberInListInner}>
                      <Avatar
                        key={'member_' + member.user_id}
                        userId={member.user_id}
                        profilePicture={member.profile_picture_url}
                        firstname={member.firstname}
                        lastname={member.lastname}
                        imgWrapperSize='small'
                        showImageAsDecorative={true}
                        onClickAction={() => showUserLightModal(member)}
                        mimeType={member.mime_type}
                        originalTag={member.original_tag}
                        isOriginal={member.is_original}
                        withExpertiseGroup={member.with_expertise_group}
                      />

                      <button
                        type='button'
                        onClick={() => addMemberToInvite(member)}
                        className={parentStyles.addRemoveIconButton}>
                        <div className={parentStyles.userProfile}>
                          {search ? (
                            <span
                              className={parentStyles.memberName}
                              dangerouslySetInnerHTML={{ __html: completeNameHTML }}
                            />
                          ) : (
                            <span className={parentStyles.memberName}>{completeName}</span>
                          )}
                        </div>

                        <Icon name='add' size='large' styleModifier={parentStyles.addRemoveIcon} />
                      </button>
                    </div>
                  </div>
                )
              })}
          {loadingInSidebar || (searchedMemberError && searchedMemberError === 'cancelTokenError') ? (
            <Spinner isWhite={true} />
          ) : null}
        </div>
        <div className={parentStyles.finalLine}></div>
      </React.Fragment>
    </React.Fragment>
  )
}
